<div class="modal-body">
  <div id="modal-header-wrapper">
    <h2 id="title-text">{{ title }}</h2>
    <p *ngIf="subtitle" id="subtitle-text" [innerHTML]="subtitle"></p>
  </div>

  <div *ngIf="question" id="modal-content-wrapper">
    <div class="form-row-wrapper">
      <div id="phone-form" class="form-field input-row" [class.required]="requiredQuestion">
        <label>{{ question }}</label>
        <ng-container *ngIf="answers else inputTemplate">
          <select [(ngModel)]="answer" class="form-control custom-select">
            <option *ngFor="let answer of answers" [ngValue]="answer.code">{{ answer.label }}</option>
          </select>
        </ng-container>
        <ng-template #inputTemplate>
          <input [class.is-invalid]="questionInvalid"
                 [(ngModel)]="answer"
                 class="form-control"
                 type="text">
        </ng-template>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button id="cancel-button" (click)="hideModal(); cancel.emit();" type="button"
            class="btn btn-outline-primary btn-outline text-only">
      {{ cancelLabel ?? 'Annuler' }}
    </button>

    <button id="validate-button"
            (click)="hideModal(); validate.emit(answer)"
            [disabled]="!enableValidate()"
            type="button"
            class="btn btn-primary btn-gradient">
      {{ validateLabel ?? 'Valider' }}
    </button>
  </div>
</div>
